// CODE_COMMENTS_277

import React from 'react'
import { Card, Image } from 'semantic-ui-react'

import { useTranslation } from 'react-i18next'
import GridOfContainerTypeInfo from '../ContainerTypesDifferences/ContainerTypeCard/GridOfContainerTypeInfo'

import InformationalPopup from '../../../../common-components/InformationalPopup'

import { CONTAINER_TYPES, CONTAINER_TYPES_CCP } from '../../../../constants'

import cbiCasePlasticPallet from '../../../../public/imagesAndIcons/cbi-case-plastic-pallet.jpg'

export default () => {
  const { t: translate } = useTranslation('common')
  const header = CONTAINER_TYPES.find(o => o.id === CONTAINER_TYPES_CCP).name || ''
  return (
    <InformationalPopup
      content={
        <Card>
          <Image src={cbiCasePlasticPallet} />
          <Card.Content>
            <Card.Header>{translate(header)}</Card.Header>
            <Card.Description>
              <GridOfContainerTypeInfo
                info={[
                  { label: translate('Width'), measurement: '41.4"' },
                  { label: translate('Length'), measurement: '37.4"' },
                  { label: translate('Height'), measurement: '6"' },
                ]}
              />
            </Card.Description>
          </Card.Content>
        </Card>
      }
      popupProps={{
        flowing: true,
        position: 'right center'
      }}
    />
  )
}
